function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function setActive() {

  var subNavAnchors = $('.js-sub-nav--pageanchors');

  $(window).on('optimizedScroll', function() {

    var linkToMakeActive;
    var $prev;

    $('a', subNavAnchors).each(function(i, link) {
      var $link = $(link);
      var href = $link.attr('href');
      if (href.substring(0,1) === '#') {
        var $el = $(href);
        var elOffsetWindowTop = Math.floor($el.offset().top - $(window).scrollTop());
        var inTopHalfOfWindow = elOffsetWindowTop - ($(window).height() / 2) <= 0;
        var previousBeyondWindow = ($prev ? ($prev.offset().top + $el.prev().outerHeight()) < $(window).scrollTop() : true);
        if (inTopHalfOfWindow && previousBeyondWindow) {
          linkToMakeActive = link;
        }
      }
    });

    $(linkToMakeActive).parent().find('.sub-nav__link--active').removeClass('sub-nav__link--active');
    $(linkToMakeActive).addClass('sub-nav__link--active');

  });

}

setTimeout(setActive, 2000);


(async () => {
  
  await customElements.whenDefined('nano-global-nav');
  const globalNav = document.querySelector("nano-global-nav");
  await globalNav.componentOnReady();

  document.querySelector('nano-global-nav').activeMyAccountSections = ['loggedin', 'sites', 'icons'];

  document.querySelectorAll('.back-btn').forEach(btn => {
    btn.addEventListener('click', ev => {
      ev.target.parentElement.closest('nano-nav-item').open = false;
    })
  })
  document.querySelectorAll('.close-cookie').forEach(btn => {
    btn.addEventListener('click', ev => {
      ev.target.parentElement.closest('nano-nav-item').open = false;
    })
  })
  document.querySelector('nano-global-nav').addEventListener('nanoIsReady', (e) => {
    if (!getCookie('UserHasExplored')) {
      var resourcesnavitem = document.querySelector('#explore');
      var cookieclosebtn = document.querySelector('.close-cookie');

      cookieclosebtn.style.display = 'block';
      resourcesnavitem.open = true;

      resourcesnavitem.addEventListener('nanoClose', () => {
        setCookie('UserHasExplored', 'true')
      })
    }
  });

  // await customElements.whenDefined('nano-sticker');
  // const stickers = document.querySelectorAll("nano-sticker");
  // stickers.forEach(sticker => {
  //   sticker.scrollParent = document;
  // });
})();
